export default __webpack_public_path__ + "static/media/cancel.81e2a42b.png";